import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, buttonStyle, fontWeightBold } from '../../../helpers/getEmailStyles';

class CompletedReservationGuest extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      hostName: PropTypes.string.isRequired,
      hostProfilePic: PropTypes.string.isRequired,
    }).isRequired
  };

  render() {
    const { content: { reservationId, logo, siteName, guestName } } = this.props;
    const { content: { hostName, hostProfilePic } } = this.props;
    let messageURL = url + '/review/write/' + reservationId;
    let imageURL;
    if (hostProfilePic) {
      imageURL = url + '/images/avatar/medium_' + hostProfilePic;
    }

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {guestName},
          </div>
          <EmptySpace height={20} />
          <div>
            Vous avez effectué votre départ — c'est le moment idéal pour laisser un avis !
            <EmptySpace height={10} />
            Faites savoir à {hostName} ce que vous avez aimé et comment il peut améliorer son annonce. Vos commentaires l'aident à améliorer son espace et à offrir une expérience encore meilleure !
          </div>
          <EmptySpace height={30} />
          <div>
            <a href={messageURL} style={buttonStyle}>Laisser un avis</a>
          </div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default CompletedReservationGuest;